export default {"src":"/_next/static/media/arrow_right.8e0cb5df.svg","height":48,"width":48};